import { Link } from "react-router-dom";
import { ArrowRight, Sun, Truck, Backpack, Layers, Grid3X3, Battery, Wrench, Home, Maximize2 } from "lucide-react";

const USE_CASES = [
  { title: "Highest Efficiency Panels", path: "/highest-efficiency-solar-panels", icon: Sun, desc: "Top-performing panels rated by efficiency" },
  { title: "Best Solar Panels for RV", path: "/best-solar-panels-for-rv", icon: Truck, desc: "Rigid, flexible & portable RV options" },
  { title: "Best Portable Solar Panels", path: "/best-portable-solar-panels", icon: Backpack, desc: "For camping, van life & emergencies" },
  { title: "Best Flexible Solar Panels", path: "/flexible-solar-panels", icon: Layers, desc: "Lightweight panels for curved surfaces" },
  { title: "Best Bifacial Solar Panels", path: "/bifacial-solar-panels", icon: Grid3X3, desc: "Dual-sided panels for max production" },
  { title: "Best for Solar Generators", path: "/best-solar-panels-for-solar-generators", icon: Battery, desc: "Compatible with EcoFlow, Jackery, Bluetti" },
  { title: "Solar Panel Kits", path: "/best-high-efficiency-solar-panels", icon: Wrench, desc: "Complete kits with controllers & wiring" },
  { title: "Best for Camping", path: "/best-portable-solar-panels", icon: Backpack, desc: "Foldable & lightweight for the trail" },
  { title: "Home Backup Panels", path: "/best-high-efficiency-solar-panels", icon: Home, desc: "Emergency power for essential loads" },
  { title: "Best for Small Spaces", path: "/highest-efficiency-solar-panels", icon: Maximize2, desc: "Max output from limited area" },
];

export default function UseCaseSection() {
  return (
    <section className="py-16 lg:py-24 bg-secondary/30">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <span className="text-[11px] font-mono uppercase tracking-[0.2em] text-accent-text font-semibold">Browse by Use Case</span>
          <h2 className="font-heading font-bold text-3xl lg:text-4xl mt-1 mb-3">
            Find the Best Solar Panel for Your Needs
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            In-depth guides for every solar use case — from rooftop installations to portable camping setups.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 lg:gap-4">
          {USE_CASES.map((uc, i) => (
            <Link
              key={i}
              to={uc.path}
              className="group bg-card border border-border rounded-xl p-4 lg:p-5 hover:border-accent/50 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-9 h-9 rounded-xl bg-accent/10 flex items-center justify-center mb-3 group-hover:bg-accent/20 group-hover:scale-110 transition-all duration-300">
                <uc.icon className="w-5 h-5 text-accent" />
              </div>
              <h3 className="font-heading font-semibold text-sm mb-1 group-hover:text-accent transition-colors leading-snug">
                {uc.title}
              </h3>
              <p className="text-xs text-muted-foreground leading-relaxed hidden lg:block">{uc.desc}</p>
              <div className="flex items-center gap-1 mt-2 text-xs font-medium text-accent opacity-0 group-hover:opacity-100 transition-all duration-200 translate-x-0 group-hover:translate-x-1">
                View guide <ArrowRight className="w-3 h-3" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}